import type { SceneDef, SceneKey } from './types';
import { incline } from './incline';
import { projectile } from './projectile';
import { pendulum } from './pendulum';
import { springMass } from './spring-mass';
import { collisions } from './collisions';
import { atwood } from './atwood';
import { circular } from './circular';
import { sandbox } from './sandbox';

export const SCENES: Record<SceneKey, SceneDef> = {
  incline,
  projectile,
  pendulum,
  springMass,
  collisions,
  atwood,
  circular,
  sandbox,
};

export type {
  SceneDef,
  SceneKey,
  BuildContext,
  BuiltScene,
  ForceVector,
  SceneParam,
} from './types';
